import { createSchemaField } from '@formily/react';
import { componentMap } from '@/form/component-map';
export var SchemaField = createSchemaField({
    components: componentMap,
});
